import { UserStatus } from "@/types/User";
import { api } from "..";
import { MatchStatus } from "@/types/SportsApiResponses";

interface UpdateMatchesStatusPayload {
  status: MatchStatus;
  matchIds: number[];
}

export const updateMatchesStatus = async (
  payload: UpdateMatchesStatusPayload
) => {
  const res = await api.client.put("/matches/status", payload);
  return res.data;
};
